import React from "react";

export interface Props {
	schema: VideoSchema | FAQSchema;
}

export interface VideoSchema {
	"@context": string;
	"@type": string;
	name: string;
	description: string;
	uploadDate: string;
	embedUrl: string;
	contentUrl: string;
	thumbnailUrl: Array<string>;
}

export interface FAQSchema {
	"@type": string;
	"@context": string;
	mainEntity: Array<{
		"@type": string;
		name: string;
		acceptedAnswer: {
			"@type": string;
			text: string;
		};
	}>;
}

export class StructuredDataSchema extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const { schema } = this.props;

		return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
	}
}
